import PropTypes from 'prop-types';
import { createContext, useEffect, useMemo } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { getForcedPresetColor } from 'utils/environment';

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext(undefined);

function getInitialConfig() {
  const forced = getForcedPresetColor();
  if (forced) {
    return { ...config, presetColor: forced };
  }
  return config;
}

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }) {
  const defaultConfig = useMemo(() => getInitialConfig(), []);
  const { state, setState, setField, resetState } = useLocalStorage('mantis-react-js-config', defaultConfig);

  // Test / Dev hosts: keep the hostname preset (do not trust localStorage from other env visits).
  useEffect(() => {
    const forced = getForcedPresetColor();
    if (forced && state.presetColor !== forced) {
      setField('presetColor', forced);
    }
  }, [state.presetColor, setField]);

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}

ConfigProvider.propTypes = { children: PropTypes.node };
